export default __webpack_public_path__ + "static/Plots0046-1a640dc804aa81376191acd39783bd58.jpg";